import { ApplicationTypes } from 'metalworks-domain'

import { configuratorInterface } from '../configurator-interface'

/** Standardize the plate preview and ensure finalization starts from the expected scene state. */
export const resetToolAndViewOnSummaryAndFinalizationTransformer = configuratorInterface.transformerBuilder.when
  .navigated({
    to: [ApplicationTypes.NavigationState.Summary, ApplicationTypes.NavigationState.Finalization],
  })
  .and(ctx => {
    const { navigationSystem } = ctx.domainContext
    const oldState = ctx.getOldState()

    return (
      navigationSystem.getActiveToolState(oldState) !== ApplicationTypes.ToolState.Configure ||
      navigationSystem.getActiveViewState(oldState) !== ApplicationTypes.ViewState['3d']
    )
  })
  .then.applySideEffect(ctx => [
    ctx.domainContext.navigationSystem.getToolUpdate(ApplicationTypes.ToolState.Configure),
    ctx.domainContext.navigationSystem.getViewUpdate(ApplicationTypes.ViewState['3d']),
  ])
  .build('Reset tool and view on Summary and Finalization')
